import { render, staticRenderFns } from "./NewOrders.vue?vue&type=template&id=771322c4&"
import script from "./NewOrders.vue?vue&type=script&lang=js&"
export * from "./NewOrders.vue?vue&type=script&lang=js&"
import style0 from "./NewOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewOrders.vue"
export default component.exports